/* PureEthical - cabecalho mobile numa linha (< 1000px) + utilitarios na gaveta.
   [menu] [pesquisa] ... LOGOTIPO ... [conta] [cesto]
   Reencaminha para os botoes originais do tema. */
(function () {
  var MOBILE = '(max-width: 999px)';
  var S = 'viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'currentColor\' stroke-width=\'1.8\' stroke-linecap=\'round\' stroke-linejoin=\'round\'';
  var ICON = {
    menu: '<svg ' + S + '><line x1=\'3\' y1=\'8.5\' x2=\'21\' y2=\'8.5\'/><line x1=\'3\' y1=\'15.5\' x2=\'21\' y2=\'15.5\'/></svg>',
    search: '<svg ' + S + '><circle cx=\'10.5\' cy=\'10.5\' r=\'7\'/><path d=\'m20.5 20.5-5.1-5.1\'/></svg>',
    account: '<svg ' + S + '><circle cx=\'12\' cy=\'8\' r=\'3.6\'/><path d=\'M5 20.5a7 7 0 0 1 14 0\'/></svg>',
    cart: '<svg ' + S + '><path d=\'M6 8h12l-1 12H7L6 8z\'/><path d=\'M9.2 8V6.4a2.8 2.8 0 0 1 5.6 0V8\'/></svg>',
    wl: '<svg ' + S + '><path d=\'M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21.2l7.8-7.7 1-1.1a5.5 5.5 0 0 0 0-7.8z\'/></svg>'
  };

  /* v29 Fase 2: textos (so aria-label) nas 6 linguas da loja */
  var LANG = (document.documentElement.lang || 'pt').toLowerCase().split('-')[0];
  var TXTS = {
    pt: { menu: 'Menu', search: 'Pesquisar', account: 'Conta', cart: 'Cesto', wl: 'Favoritos', country: 'País e moeda' },
    en: { menu: 'Menu', search: 'Search', account: 'Account', cart: 'Bag', wl: 'Wishlist', country: 'Country & currency' },
    es: { menu: 'Menú', search: 'Buscar', account: 'Cuenta', cart: 'Cesta', wl: 'Favoritos', country: 'País y moneda' },
    fr: { menu: 'Menu', search: 'Rechercher', account: 'Compte', cart: 'Panier', wl: 'Favoris', country: 'Pays et devise' },
    de: { menu: 'Menü', search: 'Suchen', account: 'Konto', cart: 'Warenkorb', wl: 'Favoriten', country: 'Land & Währung' },
    it: { menu: 'Menu', search: 'Cerca', account: 'Account', cart: 'Carrello', wl: 'Preferiti', country: 'Paese e valuta' }
  };
  var TXT = TXTS[LANG] || TXTS.en;

  var cartObserver = null;
  var cartBadge = null;
  var wlObserver = null;
  var wlBadge = null;

  /* v29 Fase 2: coracao dos favoritos no cabecalho do telemovel, com o mesmo numero do #wlBadge */
  function syncWl() {
    if (!wlBadge) return;
    var src = document.getElementById('wlBadge');
    var n = src ? (src.textContent || '').trim() : '';
    var show = n && n !== '0';
    wlBadge.textContent = show ? n : '';
    wlBadge.style.display = show ? 'flex' : 'none';
  }
  function watchWl() {
    var src = document.getElementById('wlBadge');
    if (wlObserver) { wlObserver.disconnect(); wlObserver = null; }
    syncWl();
    if (src && window.MutationObserver) {
      wlObserver = new MutationObserver(syncWl);
      wlObserver.observe(src, { childList: true, characterData: true, subtree: true });
    }
  }

  function tap(sel, fallback) {
    var el = document.querySelector(sel);
    if (el) { el.click(); return; }
    if (typeof fallback === 'function') fallback();
    else if (fallback) window.location.href = fallback;
  }

  /* sem texto por baixo do icone: o nome fica so no aria-label */
  function item(key, tag) {
    var el = document.createElement(tag);
    el.className = 'pe-tab pe-tab--' + key;
    el.innerHTML = ICON[key];
    if (tag === 'button') el.type = 'button';
    el.setAttribute('aria-label', TXT[key]);
    el.setAttribute('title', TXT[key]);
    return el;
  }

  function syncCart() {
    if (!cartBadge) return;
    var pill = document.querySelector('.cart-pill');
    var n = pill ? (pill.textContent || '').trim() : '';
    var show = n && n !== '0';
    cartBadge.textContent = show ? n : '';
    cartBadge.style.display = show ? 'flex' : 'none';
  }

  function watchCart() {
    var pill = document.querySelector('.cart-pill');
    if (cartObserver) { cartObserver.disconnect(); cartObserver = null; }
    syncCart();
    if (pill && window.MutationObserver) {
      cartObserver = new MutationObserver(syncCart);
      cartObserver.observe(pill, { childList: true, characterData: true, subtree: true, attributes: true });
    }
  }

  function buildBar() {
    var header = document.querySelector('.site-header');
    if (!header || header.querySelector('.pe-tabbar')) return;

    var bar = document.createElement('nav');
    bar.className = 'pe-tabbar';
    bar.setAttribute('aria-label', TXT.menu);

    var menu = item('menu', 'button');
    menu.addEventListener('click', function () {
      tap('#burgerBtn', function () { if (window.openMobile) window.openMobile(); });
    });

    var search = item('search', 'button');
    search.addEventListener('click', function () {
      tap('#searchBtn', function () {
        if (window.openSearch) window.openSearch();
        else window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'search'; /* v30 Fase 1F: com o prefixo da lingua */
      });
    });

    var account = item('account', 'a');
    account.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'account'; /* v30 F1: com o prefixo da lingua */

    var cart = item('cart', 'button');
    cartBadge = document.createElement('span');
    cartBadge.className = 'pe-tab-badge';
    cart.appendChild(cartBadge);
    cart.addEventListener('click', function () {
      tap('#cartBtn', function () {
        if (window.openCart) window.openCart();
        else window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart' /* v30: com o prefixo da lingua */;
      });
    });

    var wl = item('wl', 'button');
    wlBadge = document.createElement('span');
    wlBadge.className = 'pe-tab-badge';
    wl.appendChild(wlBadge);
    wl.addEventListener('click', function () { tap('#wishlistBtn', null); });

    bar.appendChild(menu);
    bar.appendChild(search);
    bar.appendChild(account);
    bar.appendChild(wl);
    bar.appendChild(cart);
    header.appendChild(bar);
    document.body.classList.add('pe-has-tabbar');

    /* v30 Fase 1F: menu e pesquisa dizem se estao abertos (leitores de ecra) - so atributos, o comportamento nao muda */
    function syncOpen(btn, id) {
      var el = document.getElementById(id);
      if (!el || !window.MutationObserver) return;
      btn.setAttribute('aria-controls', id);
      var upd = function () {
        var on = el.classList.contains('on') || el.classList.contains('open') || el.getAttribute('aria-hidden') === 'false';
        btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      };
      upd();
      new MutationObserver(upd).observe(el, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
    }
    syncOpen(menu, 'mobileNav');
    syncOpen(search, 'searchPanel');

    watchCart();
    watchWl();
  }

  var moved = [];

  function stash(el) {
    if (!el || el.dataset.peMoved) return null;
    el.dataset.peMoved = '1';
    moved.push({ el: el, parent: el.parentNode, next: el.nextSibling });
    return el;
  }

  function bindCountryToggle(picker) {
    if (!picker || picker.dataset.peCountryBound) return;
    picker.dataset.peCountryBound = '1';

    var btn = picker.querySelector('#countryBtn') || picker.querySelector('.country-btn');
    var drop = picker.querySelector('#countryDrop') || picker.querySelector('.country-drop');
    if (!btn || !drop) return;

    function toggle(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      var open = drop.classList.toggle('pe-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      drop.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) {
        var input = drop.querySelector('#countrySearch');
        if (input) setTimeout(function () { try { input.focus(); } catch (err) {} }, 120);
      }
    }

    btn.addEventListener('click', toggle);
    btn.addEventListener('touchend', toggle);

    var closeBtn = drop.querySelector('#countryClose');
    if (closeBtn) closeBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      drop.classList.remove('pe-open');
      btn.setAttribute('aria-expanded', 'false');
    });

    document.addEventListener('click', function (e) {
      if (!drop.classList.contains('pe-open')) return;
      if (picker.contains(e.target)) return;
      drop.classList.remove('pe-open');
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  function moveUtils() {
    var nav = document.querySelector('.mobile-nav');
    if (!nav || nav.querySelector('.mn-utils')) return;

    var country = document.getElementById('countryPicker');
    var wl = document.getElementById('wishlistBtn');
    if (!country && !wl) return;

    var box = document.createElement('div');
    box.className = 'mn-utils';

    if (wl && stash(wl)) {
      if (!wl.querySelector('[data-pe-lbl]')) {
        var lbl = document.createElement('span');
        lbl.className = 'mn-util-lbl';
        lbl.setAttribute('data-pe-lbl', '1');
        lbl.textContent = TXT.wl;
        wl.appendChild(lbl);
      }
      wl.classList.add('mn-util');
      if (!wl.dataset.peWlBound) {
        wl.dataset.peWlBound = '1';
        wl.addEventListener('click', function () {
          if (window.closeAll) window.closeAll();
        }, true);
      }
      box.appendChild(wl);
    }

    if (country && stash(country)) {
      country.classList.add('mn-util');
      if (!country.querySelector('[data-pe-lbl]')) {
        var clbl = document.createElement('span');
        clbl.className = 'mn-util-lbl mn-util-lbl--country';
        clbl.setAttribute('data-pe-lbl', '1');
        clbl.textContent = TXT.country;
        country.insertBefore(clbl, country.firstChild);
      }
      bindCountryToggle(country);
      box.appendChild(country);
    }

    var links = nav.querySelector('.mn-foot-links');
    if (links && links.parentNode) links.parentNode.insertBefore(box, links);
    else nav.appendChild(box);
  }

  function restoreUtils() {
    moved.slice().reverse().forEach(function (m) {
      if (!m.el || !m.parent) return;
      if (m.next && m.next.parentNode === m.parent) m.parent.insertBefore(m.el, m.next);
      else m.parent.appendChild(m.el);
      m.el.classList.remove('mn-util');
      delete m.el.dataset.peMoved;
      var labels = m.el.querySelectorAll('[data-pe-lbl]');
      Array.prototype.forEach.call(labels, function (l) { l.remove(); });
    });
    moved = [];
    var box = document.querySelector('.mn-utils');
    if (box) box.remove();
  }

  function apply() {
    if (window.matchMedia(MOBILE).matches) {
      buildBar();
      moveUtils();
    } else if (moved.length) {
      restoreUtils();
    }
  }

  function init() {
    apply();

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(apply, 200);
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target || !e.target.querySelector) return;
      if (!e.target.querySelector('.site-header') && !e.target.querySelector('.mobile-nav')) return;
      moved = [];
      cartBadge = null; wlBadge = null;
      if (cartObserver) { cartObserver.disconnect(); cartObserver = null; }
      if (wlObserver) { wlObserver.disconnect(); wlObserver = null; }
      document.body.classList.remove('pe-has-tabbar');
      apply();
    });

    window.addEventListener('pageshow', function (e) { if (e.persisted) syncCart(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
